import { address } from "./address";
import { autoShip } from "./autoShip";
import { cart } from "./cart";
import { checkout } from "./checkout";
import { checkoutScheduledReplenishment } from "./checkoutScheduledReplenishment";
import { common } from "./common";
import { contactFactory } from "./contactFactory";
import { importExport } from "./importExport";
import { limitedAvailability } from "./limitedAvailability";
import { order } from "./order";
import { payment } from "./payment";
import { product } from "./product";
import { quickOrder } from "./quickOrder";
import { savedAddress } from "./savedAddress";
import { savedCart } from "./savedCart";
import { shippingAccounts } from "./shippingAccounts";
import { spSearch } from "./spSearch";
import { userAccount } from "./userAccount";

export const en = {
  autoShip,
  cart,
  product,
  common,
  userAccount,
  importExport,
  limitedAvailability,
  savedCart,
  quickOrder,
  checkout,
  address,
  order,
  contactFactory,
  shippingAccounts,
  savedAddress,
  checkoutScheduledReplenishment,
  payment,
  spSearch,
};
